module.exports = __webpack_public_path__ + "static/media/add_white.25f472cc.svg";